import { Component, Inject, OnDestroy, OnInit, Optional } from '@angular/core';
import { AbstractControl, ControlContainer, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { showAnimation } from 'src/animations';
import { QuillNoteTypeMismatchDialogComponent } from 'src/app/lib/shared/components/dialog/quill-note-type-mismatch-dialog/quill-note-type-mismatch-dialog.component';
import { quillOptions } from '../../../globals';
import { IIssueTransactionView } from '../../../interfaces';
import { STEP_FORM_GROUP } from '../../dialog/issue-transaction-dialog2/issue-transaction-dialog2-component-classes';

@Component({
  selector: 'app-issue-form',
  templateUrl: './issue-form.component.html',
  styleUrls: ['./issue-form.component.css'],
  animations: [ showAnimation ]
})
export class IssueFormComponent implements IIssueTransactionView, OnDestroy, OnInit {

  private _subscriptions: Subscription[] = [];

  constructor(
    @Optional() @Inject(STEP_FORM_GROUP) public formGroup: FormGroup,
    private _dialog: MatDialog,
    @Optional() private _controlContainer: ControlContainer
  ) { }

  ngOnDestroy(): void {
    for(let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    if(!this.formGroup && this._controlContainer.control) this.formGroup = this._controlContainer.control as FormGroup; 
    if(this.noteControl.value && this.noteControl.value.startsWith('{"ops":[{')){
      this._dialog.open(QuillNoteTypeMismatchDialogComponent, {
        panelClass: 'no-padding-dialog-container',
        data: this.noteControl.value
      }).afterClosed().subscribe((htmlResult: string) => {
        if(htmlResult){
          this.noteControl.setValue(htmlResult);
          this.noteControl.markAsDirty();
        }
      });
    }
  }

  public customerFormControl: FormControl = new FormControl(null, Validators.compose([Validators.required]));

  // quill
  public quillModules = quillOptions;

  get customerControl(): AbstractControl {
    return this.formGroup.controls['issuecustomer'];
  }
  get numberControl(): AbstractControl {
    return this.formGroup.controls['issuenumber'];
  }
  get typeControl(): AbstractControl {
    return this.formGroup.controls['issuetype'];
  }
  get noteControl(): AbstractControl {
    return this.formGroup.controls['issuenote'];
  }

}
